<div class="text-center py-3">
    <h5 class="h4-responsive px-3 mt-3 border-0" style="font-weight:400;">Currently, there are no {{ message }}.</h5>
</div>